
import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { DettaglioTavola } from "../types"
import { API_URL } from "../constants"

export function useDettagliTavolaList(params: Record<string, string> = {}) {
  return useList<DettaglioTavola>(`${API_URL}/admin/dettagli-tavola`, {
    query: params,
  })
}

export function useDettaglioTavola(id: number | undefined) {
  return useDetail<DettaglioTavola>(`${API_URL}/admin/dettagli-tavola`, id?.toString())
}

export function useDettaglioTavolaCreate() {
  return useCreate<DettaglioTavola>(`${API_URL}/admin/dettagli-tavola`)
}

export function useDettaglioTavolaUpdate() {
  return useUpdate<DettaglioTavola>(`${API_URL}/admin/dettagli-tavola`)
}

export function useDettaglioTavolaDelete() {
  return useDelete<DettaglioTavola>(`${API_URL}/admin/dettagli-tavola`)
}